(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EnvironmentDeleteController',EnvironmentDeleteController);

    EnvironmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Environment'];

    function EnvironmentDeleteController($uibModalInstance, entity, Environment) {
        var vm = this;

        vm.environment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Environment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
